import React, { Component } from 'react';
import {
    Table,
    Modal,

} from 'react-bootstrap'
import './FeedbackViewModal.css'
var dateFormat = require('dateformat');


class FeedbackViewModal extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }





    render() {
        // console.log("=====================>", this.props.feedbkDtls && this.props.feedbkDtls.item)

        const data = this.props.feedbkDtls && this.props.feedbkDtls.item
            ? this.props.feedbkDtls && this.props.feedbkDtls.item
            : null

        return (
            <div>
                <div>
                    <Modal show={this.props.show}
                        onHide={this.props.handleClose}
                        animation={false} size="lg"
                        backdrop="static"

                    //  style={{ backgroundColor: '#00000005' }}
                    >
                        <Modal.Header style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }} closeButton>
                            <Modal.Title>
                                <span style={{ fontSize: "20px" }}>
                                    Feedback Details
                                </span>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div>
                                <div className="feedbkModalTbl" >
                                    <Table responsive bordered>
                                        <tbody>
                                            <tr>
                                                <td className="feedbkTdWdth">Feedback By</td>
                                                <td className="feedbkModalCap">
                                                    {data !== null && data.userId.name}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Feedback For</td>
                                                <td className="feedbkModalCap">
                                                    {/* {data !== null && data.orgId.name} */}
                                                </td>

                                            </tr>
                                            <tr>
                                                <td>Created Date</td>
                                                <td className="feedbkModalCap">
                                                    {data !== null && dateFormat(data.createdAt, "mediumDate")}
                                                </td>

                                            </tr>
                                            <tr>
                                                <td>FeedBack</td>
                                                <td className="feedbkModalCap">
                                                    {data !== null && data.userId.feedback}
                                                </td>

                                            </tr>
                                            <tr>
                                                <td>Rating</td>
                                                <td className="feedbkModalCap">
                                                    {data !== null && data.rating}
                                                </td>
                                            </tr>



                                        </tbody>
                                    </Table>
                                </div>
                            </div>




                        </Modal.Body>
                        <Modal.Footer>

                        </Modal.Footer>

                    </Modal>
                </div>
            </div>
        )
    }

}
export default FeedbackViewModal;